import { render, staticRenderFns } from "./HomeRankingSection.vue?vue&type=template&id=bfcdaf2c"
import script from "./HomeRankingSection.vue?vue&type=script&lang=js"
export * from "./HomeRankingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports